import { Outlet, useLocation } from "react-router-dom"
import { useLayoutEffect, useRef, useState } from "react"

import { APP_ROUTES } from "@/constants/routes"
import { Layout } from "./index"
import { logPageView } from "@/lib/firebase"
import { useIntl } from "react-intl"

const PATH_TITLE_KEYS: Record<string, string> = {
  "/": "dashboard.title",
  [APP_ROUTES.gasAccount]: "gasAccount.title",
  [APP_ROUTES.policies]: "policies.title",
  [APP_ROUTES.policyCreate]: "policyCreate.title",
  [APP_ROUTES.ads]: "ads.title",
  [APP_ROUTES.adCreate]: "adCreate.title",
  [APP_ROUTES.analytics]: "analytics.title",
  [APP_ROUTES.settings]: "settings.title",
}

function getTitleKeyFromPath(pathname: string): string {
  if (PATH_TITLE_KEYS[pathname]) return PATH_TITLE_KEYS[pathname]
  if (/^\/policies\/[^/]+\/edit$/.test(pathname))
    return "policyCreate.editTitle"
  if (/^\/policies\/[^/]+$/.test(pathname)) return "policies.policyDetails"
  if (/^\/ads\/[^/]+\/edit$/.test(pathname)) return "ads.editTitle"
  if (/^\/ads\/[^/]+$/.test(pathname)) return "ads.adDetailTitle"
  return "dashboard.title"
}

export function LayoutWrapper() {
  const intl = useIntl()
  const location = useLocation()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const [title, setTitle] = useState(() =>
    intl.formatMessage({ id: getTitleKeyFromPath(location.pathname) })
  )

  useLayoutEffect(() => {
    setTitle(intl.formatMessage({ id: getTitleKeyFromPath(location.pathname) }))
  }, [location.pathname, intl])

  useLayoutEffect(() => {
    logPageView(
      location.pathname,
      intl.formatMessage({ id: getTitleKeyFromPath(location.pathname) })
    )
  }, [location.pathname, intl])

  useLayoutEffect(() => {
    scrollContainerRef.current?.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <Layout
      title={title}
      pageResetKey={location.pathname}
      headerWarning={undefined}
      scrollContainerRef={scrollContainerRef}
    >
      <Outlet context={{ setLayoutTitle: setTitle }} />
    </Layout>
  )
}
